import { Collapse, Grid, ListItemButton } from "@mui/material";
import { Fragment, useState } from "react";

interface Props {
  content: (isOpen: boolean) => React.ReactNode;
  children?: any;
  defaultOpen: boolean;
}

export default (props: Props) => {
  const [isOpen, setOpen] = useState(props.defaultOpen);

  return (
    <Fragment>
      <ListItemButton
        dense
        disableGutters
        onClick={() => setOpen(!isOpen)}
        sx={{ width: "100%" }}
      >
        <Grid
          size={12}
          style={{ verticalAlign: "middle", lineHeight: "0px", width: "100%" }}
        >
          {props.content(isOpen)}
        </Grid>
      </ListItemButton>

      <Grid size={12}>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          {props.children}
        </Collapse>
      </Grid>
    </Fragment>
  );
};
